import React, { useState, useEffect } from "react";
import RBPageCotainer from "./RBPageContainer";
import classes from "./styles/style.module.css";
import { motion } from "framer-motion";
import errorHandler from "../../assets/utils/ErrorHandler";
import api from "../../assets/utils/Api";
import CountUp from "react-countup";
import VideoPlayer from "../../assets/components/VideoPlayer";
import { FaPlay } from "react-icons/fa6";

const RbVow = () => {
  const [bottels, setBottels] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const getBottelsCount = () => {
    api
      .post("/vow/total", {
        type: "Water",
      })
      .then(({ data }) => {
        setBottels(data.data * 4);
      })
      .catch((error) => {
        errorHandler(error);
      });
  };

  useEffect(() => {
    getBottelsCount();
  }, []);

  return (
    <RBPageCotainer>
      <div className="px-3">
        <div className={classes.vowContainer}>
          <div className={classes.hadisContainer}>
            <p>
              "الإمامُ الباقرُ عليه السلام: مَن سَقى ظَمآنا ماءً سَقاهُ اللّه
              ُمِنَ الرَّحيقِ المَختومِ . [بحار الأنوار]
            </p>
            <p className="mb-0">
              امام باقر عليه السلام: هر كه به تشنه كامى آب بنوشاند خداوند او را
              از شراب سر به مُهر بهشتى بنوشاند."
            </p>
          </div>
          <h3>بطری آب نذر راه بهشت</h3>
          <h4>(راهپیمایی اربعین)</h4>
          <h1>
            <CountUp end={bottels} />
          </h1>
          <motion.div
            initial={{ opacity: 0, y: 80 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.7 }}
            className={classes.hintContainer}
          >
            <div className={classes.hintOverlay}>
              <div
                className={classes.playContainer}
                onClick={() => setIsOpen(true)}
              >
                <FaPlay fontSize={20} onClick={() => setIsOpen(true)} />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
      <VideoPlayer
        open={isOpen}
        closeHandler={() => setIsOpen(false)}
        videoUrl={
          "https://api.v2.rahebehesht.com/file/get/95cd8d78-a51c-4035-8bb7_1725186832.mp4"
        }
      />
    </RBPageCotainer>
  );
};

export default RbVow;
